export const SIGNAL_TYPE_MAP: Record<string, string> = {
  // 核心趋势与反转 (High Conviction)
  'Trend Reversal': '趋势反转',
  'Trend Continuation': '趋势延续',
  'Trend Continuation (Breakdown)': '趋势延续 (跌破)',
  'Trend Continuation (Breakout)': '趋势延续 (突破)',
  'Trend Continuation + OB Retest': '趋势延续 + 订单块回踩',
  'Trend Continuation / FVG Mitigation': '趋势延续 / FVG缓解',
  'Trend Continuation / Structure Retest': '趋势延续 / 结构回踩',
  'Price Breakout': '价格突破',
  'Breakdown Continuation': '跌破延续',
  'Support Bounce': '支撑反弹',
  'Resistance Rejection': '阻力拒绝',
  'Divergence': '背离',
  'Market Structure Break': '市场结构破坏',
  'Market Structure Break (Bearish)': '市场结构破坏 (看跌)',
  'Market Structure Break (Continuation)': '市场结构破坏 (延续)',
  'Market Structure Break (Major)': '市场结构破坏 (主要)',
  'Market Structure Break (Retest)': '市场结构破坏 (回踩)',
  'Market Structure Break (Trend Continuation)': '市场结构破坏 (趋势延续)',
  'Market Structure Continuation': '市场结构延续',
  'Market Structure Continuation / Failed Sweep': '市场结构延续 / 猎杀失败',
  'Market Structure Shift': '市场结构转变',
  'Market Structure Shift (MSS)': '市场结构转变 (MSS)',
  'Market Structure Shift (15m)': '市场结构转变 (15m)',
  'Market Structure Shift (Breakout)': '市场结构转变 (突破)',
  'Market Structure Shift (Micro)': '市场结构转变 (微观)',
  'Market Structure Shift (Retest)': '市场结构转变 (回踩)',
  'Market Structure Shift (MSS) + Breaker Retest': '市场结构转变 + 破坏块回踩',
  'Market Structure Shift / Inversion FVG Retest': '市场结构转变 / 反转FVG回踩',
  'Market Structure Shift Retest': '市场结构转变回踩',
  'Micro Structure Breakout': '微观结构突破',
  'Micro Structure Shift (15m)': '微观结构转变 (15m)',
  'Micro Structure Shift (SFP)': '微观结构转变 (SFP)',
  'Micro Structure Shift (Scalp)': '微观结构转变 (超短)',
  'Micro_Structure_Breakout': '微观结构突破',
  'Trend Continuation (Micro)': '趋势延续 (微观)',
  'Trend Continuation + Micro MSS': '趋势延续 + 微观MSS',
  'Trend Continuation / Bearish Rejection': '趋势延续 / 看跌拒绝',
  'Trend Continuation / Bearish Retest': '趋势延续 / 看跌回踩',
  'Trend Continuation / Breakdown': '趋势延续 / 跌破',
  'Trend Continuation / EMA Rejection': '趋势延续 / EMA拒绝',
  'Trend Continuation / FVG Failure': '趋势延续 / FVG失效',
  'Trend Continuation / Rejection Block': '趋势延续 / 拒绝块',
  'Trend Continuation / Sweep Rejection': '趋势延续 / 猎杀拒绝',
  'Trend Continuation Breakdown': '趋势延续跌破',

  // 机构行为与流动性 (Institutional / SMC)
  // --- Order Blocks & Breakers ---
  'Order Block': '订单块',
  'Order Block Retest': '订单块回踩',
  'Order Block / FVG Retest': '订单块/FVG回踩',
  'Bullish Order Block Retest': '看涨订单块回踩',
  'Bearish Order Block & Sweep': '看跌订单块 & 扫单',
  'Bearish Order Block / FVG': '看跌订单块 / FVG',
  'Bearish Order Block / FVG Rejection': '看跌订单块/FVG拒绝',
  'Bearish Order Block / Trend Continuation': '看跌订单块 / 趋势延续',
  'Bearish Order Block Rejection': '看跌订单块拒绝',
  'Bearish Order Block Retest': '看跌订单块回踩',
  'Bearish_OrderBlock_Rejection': '看跌订单块拒绝',
  'Bearish OB Rejection': '看跌订单块拒绝',
  'Bearish Breaker Block': '看跌破坏块',
  'Bearish Breaker & FVG Retest': '看跌破坏块 & FVG回踩',
  'Bearish Breaker & Trend Continuation': '看跌破坏块 & 趋势延续',
  'Breaker Block Retest': '破坏块回踩',
  'Bullish Breaker / OB Retest': '看涨破坏块 / 订单块回踩',
  'Bearish Retest / Breaker Block': '看跌回踩/破坏块',
  'Bearish Retest (Order Block Rejection)': '看跌回踩 (订单块拒绝)',
  'Bearish Retest / Order Block': '看跌回踩 / 订单块',
  'Bullish Pinbar / Order Block': '看涨Pinbar / 订单块',
  'Order Block Retest & MSS': '订单块回踩 & MSS',
  'Order Block Retest (Trend Continuation)': '订单块回踩 (趋势延续)',
  'Order Block Retest / Trend Continuation': '订单块回踩 / 趋势延续',
  'Premium Zone Rejection / Bearish OB': '溢价区拒绝 / 看跌订单块',

  // --- Liquidity Sweeps ---
  'Liquidity Sweep': '流动性猎杀',
  'Liquidity Failure': '流动性失效',
  'Liquidity Sweep & Absorption': '流动性猎杀 & 吸筹',
  'Liquidity Sweep & Bearish Continuation': '流动性猎杀 & 看跌延续',
  'Liquidity Sweep & Bearish Rejection': '流动性猎杀 & 看跌拒绝',
  'Liquidity Sweep & Demand Retest': '流动性猎杀 & 需求区回踩',
  'Liquidity Sweep & FVG Mitigation': '流动性猎杀 & FVG缓解',
  'Liquidity Sweep & FVG Reclaim': '流动性猎杀 & FVG收回',
  'Liquidity Sweep & MSS': '流动性猎杀 & 市场结构转变',
  'Liquidity Sweep & MSS Re-test': '流动性猎杀 & MSS回踩',
  'Liquidity Sweep & Micro MSS': '流动性猎杀 & 微观结构转变',
  'Liquidity Sweep & Order Block': '流动性猎杀与订单块',
  'Liquidity Sweep & Oversold Bounce': '流动性猎杀 & 超卖反弹',
  'Liquidity Sweep & Reclaim': '流动性猎杀 & 收回',
  'Liquidity Sweep & Reclaim (SFP)': '流动性猎杀 & 收回 (SFP)',
  'Liquidity Sweep & Rejection': '流动性猎杀 & 拒绝',
  'Liquidity Sweep & Retest': '流动性猎杀 & 回踩',
  'Liquidity Sweep & SFP': '流动性猎杀 & SFP',
  'Liquidity Sweep & SFP (4H)': '流动性猎杀 & SFP (4H)',
  'Liquidity Sweep & Short Squeeze': '流动性猎杀 & 轧空',
  'Liquidity Sweep & Trend Continuation': '流动性猎杀 & 趋势延续',
  'Liquidity Sweep (Bearish SFP)': '流动性猎杀 (看跌SFP)',
  'Liquidity Sweep (Bearish)': '流动性猎杀 (看跌)',
  'Liquidity Sweep (Bullish SFP)': '流动性猎杀 (看涨SFP)',
  'Liquidity Sweep (Internal Range)': '流动性猎杀 (内部区间)',
  'Liquidity Sweep (Long)': '流动性猎杀 (做多)',
  'Liquidity Sweep (Major Demand)': '流动性猎杀 (主要需求区)',
  'Liquidity Sweep (Micro)': '流动性猎杀 (微观)',
  'Liquidity Sweep (PDH)': '流动性猎杀 (前日高点)',
  'Liquidity Sweep (Pending)': '流动性猎杀 (待定)',
  'Liquidity Sweep (Premium Zone)': '流动性猎杀 (溢价区)',
  'Liquidity Sweep (SFP)': '流动性猎杀 (SFP)',
  'Liquidity Sweep (SFP) & Absorption': '流动性猎杀 (SFP) & 吸筹',
  'Liquidity Sweep (SFP) & Rejection Block Test': '流动性猎杀 (SFP) & 拒绝块测试',
  'Liquidity Sweep (SFP) + EQH Magnet': '流动性猎杀 (SFP) + EQH磁吸',
  'Liquidity Sweep (SFP) + MSS': '流动性猎杀 (SFP) + MSS',
  'Liquidity Sweep (SFP) + RSI Divergence': '流动性猎杀 (SFP) + RSI背离',
  'Liquidity Sweep (SFP) + Volume Climax': '流动性猎杀 (SFP) + 成交量高潮',
  'Liquidity Sweep (SFP) + Volume Divergence': '流动性猎杀 (SFP) + 成交量背离',
  'Liquidity Sweep (SFP) Long': '流动性猎杀 (SFP) 做多',
  'Liquidity Sweep (Short)': '流动性猎杀 (做空)',
  'Liquidity Sweep (Turtle Soup)': '流动性猎杀 (龟汤)',
  'Liquidity Sweep + MSS': '流动性猎杀 + MSS',
  'Liquidity Sweep + RSI Divergence': '流动性猎杀 + RSI背离',
  'Liquidity Sweep Reclaim': '流动性猎杀收回',
  'Liquidity Sweep Retest (SFP)': '流动性猎杀回踩 (SFP)',
  'Liquidity Sweep Reversal (SFP)': '流动性猎杀反转 (SFP)',
  'Liquidity_Sweep_Rejection': '流动性猎杀拒绝',
  'S/R Flip & Micro Sweep': '支阻互换 & 微观猎杀',
  'SMC - Liquidity Sweep & FVG Retest': 'SMC - 流动性猎杀 & FVG回踩',
  'SMC Liquidity Sweep & Reversal': 'SMC 流动性猎杀 & 反转',
  'SMC_Liquidity_Reclaim_Pullback': 'SMC 流动性收回回调',

  // --- FVG (Fair Value Gaps) ---
  'Fair Value Gap': '失衡区回补',
  'Fair Value Gap & Liquidity Sweep': 'FVG & 流动性猎杀',
  'Fair Value Gap & MSS': 'FVG & 市场结构转变',
  'Fair Value Gap & Structure Shift': 'FVG & 结构转变',
  'Fair Value Gap (Deep Pullback)': 'FVG (深度回调)',
  'Fair Value Gap (FVG) + MSS Retracement': 'FVG + MSS回调',
  'Fair Value Gap (FVG) + Trend Continuation': 'FVG + 趋势延续',
  'Fair Value Gap (FVG) Entry': 'FVG 入场',
  'Fair Value Gap (FVG) Re-entry': 'FVG 二次入场',
  'Fair Value Gap (FVG) Rejection': 'FVG 拒绝',
  'Fair Value Gap (FVG) Retest': 'FVG 回踩',
  'Fair Value Gap (FVG) Retracement': 'FVG 回调',
  'Fair Value Gap (Limit Entry)': 'FVG (限价入场)',
  'Fair Value Gap (Retracement)': 'FVG (回调)',
  'Fair Value Gap + Liquidity Sweep': 'FVG + 流动性猎杀',
  'Fair Value Gap + Micro MSS': 'FVG + 微观结构转变',
  'Fair Value Gap Entry': 'FVG 入场',
  'Fair Value Gap Fill': 'FVG回补',
  'Fair Value Gap Rejection': 'FVG 拒绝',
  'Fair Value Gap Retest': 'FVG回踩',
  'Fair Value Gap Retest (SMC)': 'FVG 回踩 (SMC)',
  'Fair Value Gap Retest + MSS': 'FVG 回踩 + MSS',
  'Bearish FVG Rejection': '看跌FVG拒绝',
  'Bearish FVG Rejection & Trend Continuation': '看跌FVG拒绝 & 趋势延续',
  'Bearish FVG Retest': '看跌FVG回踩',
  'Bearish FVG Retest & Structure Shift': '看跌FVG回踩 & 结构转变',
  'SMC - Bullish FVG Retest & MSS': 'SMC - 看涨FVG回踩 & MSS',
  'SMC Bullish FVG Retest': 'SMC 看涨FVG回踩',
  'SMC_Bullish_FVG_Retest': 'SMC 看涨FVG回踩',

  // --- Rejections & Retests ---
  'Bearish Rejection (Macro Trend)': '看跌拒绝 (宏观趋势)',
  'Bearish Rejection (Micro Structure)': '看跌拒绝 (微观结构)',
  'Bearish Rejection (Order Block)': '看跌拒绝 (订单块)',
  'Bearish Rejection / FVG Fill': '看跌拒绝 / FVG回补',
  'Bearish Rejection / Order Block': '看跌拒绝 / 订单块',
  'Bearish Rejection / Trend Continuation': '看跌拒绝 / 趋势延续',
  'Bearish Retest (Micro Structure)': '看跌回踩 (微观结构)',
  'Bearish Retest / FVG Rejection': '看跌回踩 / FVG拒绝',
  'High Volume Demand Retest': '高量需求区回踩',
  'Limit Buy (Pin Prediction)': '限价买入 (插针预测)',
  'Limit Sell (Pin Prediction)': '限价卖出 (插针预测)',
  'SMC_Bullish_Retest': 'SMC 看涨回踩',
  'SMC_Pullback_Entry': 'SMC 回调入场',

  // --- SFP & Others ---
  'SMC - Liquidity Sweep & MSS': 'SMC - 流动性猎杀 & 结构转变',
  'SMC Bearish SFP + RSI Divergence': 'SMC 看跌SFP + RSI背离',
  'Swing Failure Pattern (SFP)': '摆动失败模式 (SFP)',
  'Bearish SFP (Swing Failure Pattern)': '看跌SFP (摆动失败模式)',
  'SFP & FVG Retest': 'SFP & FVG回踩',
  'SFP Invalidation': 'SFP失效',
  'SFP Reversal & Volume Absorption': 'SFP反转 & 成交量吸筹',
  'Daily SFP Retest & Liquidity Sweep': '日线SFP回踩 & 流动性猎杀',
  'SMC Bearish Reversal (SFP + MSS)': 'SMC 看跌反转 (SFP + MSS)',
  'SMC Reversal (Sweep + FVG Retest)': 'SMC 反转 (猎杀 + FVG回踩)',

  // --- Volatility & Absorption ---
  'Volatility Squeeze': '波动率挤压',
  'Strong Absorption': '强力吸筹',
  '15m Volatility Contraction Breakout': '15分钟波动率收缩突破',

  // 形态学 (Patterns)
  'Bull/Bear Flag': '牛/熊旗型',
  'Double Bottom/Top': '双底/双顶',

  // 辅助/次要信号 (Confirmation)
  'Golden/Death Cross': '金叉/死叉',
  'Fibonacci Retracement': '斐波那契回调',
  'Volume Anomaly': '成交量异常',
};
